




































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { ResidentModule } from '@/store/modules/resident.module'
import Vue2Filters from 'vue2-filters'
import { User } from '@/classes/User'
import Api from '@/api'
import { StatementModule } from '@/store/modules/statement.module'
import Card from '@/components/Card.vue'
import { IFacility, isObj } from '@zunta/configurations'

@Component({
  components: { Card },
  mixins: [Vue2Filters.mixin]
})
export default class PaymentSidebar extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  showOpenBalanceForResident: boolean = false
  user: User = Api.getUser() as User

  get residentId () {
    return this.$route.params.residentId
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get facilityName () {
    return isObj(this.resident) && isObj<IFacility>(this.resident.facility) ? this.resident.facility.name : null
  }

  get openBalance () {
    return this.$store.state.resident.openBalance
  }

  async fetchResidentStatementsAndToggleShowBalance () {
    if (this.user.isResident()) {
      this.showOpenBalanceForResident = false
      this.showOpenBalanceForResident = await this.statementModuleInstance.getIsUserAbleToSeeOpenBalance(this.residentId)
    }
  }

  async mounted () {
    await this.fetchResidentStatementsAndToggleShowBalance()
    await this.residentModuleInstance.fetchResidentOpenBalance(this.residentId)
  }
}
